import { LogActivity } from "./interfaces";
const DefaultOpts = {
    messageEventName: 'LocalRpcEvent'
};
/**
 * This is mostly for internal testing but does have a use/role in production, as syntactical sugar for events.
 * For example, rather than `myObserver.emit('ShowErrorAlert', 'Server is offline')` you might set up RPC with this transport
 * and then make use of with something like: alerts.show('Server is offline')
 *
 *
 */
export default class LocalObserverTransport {
    constructor(opts) {
        this._isStopped = false;
        let { observer, messageEventName } = (opts || {});
        // @ts-ignore
        observer = observer || opts;
        if (!_isEventEmitter(observer)) {
            throw new Error('InvalidArgument constructing LocalObserverTransport');
        }
        this.observer = observer;
        this.messageEventName = messageEventName || DefaultOpts.messageEventName;
        this.debugHandler = opts.debugHandler;
    }
    listen(handler) {
        this._removeExistingListener();
        this._payloadHandler = (payload) => {
            if (!this._isStopped) {
                this._debug(LogActivity.TransportReceivingMessage, { payload });
                handler(payload);
            }
        };
        this.observer.on(this.messageEventName, this._payloadHandler);
    }
    sendMessage(payload) {
        if (!this._isStopped) {
            this._debug(LogActivity.TransportSendingPayload, { payload });
            this.observer.emit(this.messageEventName, payload);
        }
    }
    stopTransport() {
        this._isStopped = true;
        this._debug(LogActivity.TransportStopping, {});
        this._removeExistingListener();
    }
    _removeExistingListener() {
        this._payloadHandler && this.observer.removeListener(this.messageEventName, this._payloadHandler);
    }
    _debug(activity, data) {
        if (!this.debugHandler) {
            return;
        }
        this.debugHandler(Object.assign({
            activity,
            endpointSenderId: this.endpointSenderId,
            messageEventName: this.messageEventName,
        }, data));
    }
}
function _isEventEmitter(obj) {
    return typeof obj === 'object' && ['on', 'emit', 'removeListener'].every(m => typeof obj[m] === 'function');
}
//# sourceMappingURL=local-observer-transport.js.map